var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTaxJar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      enableBackground: "new 0 0 180 180"
    },
    viewBox: "0 0 180 180",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 90,
    r: 88.77,
    style: {
      fill: "#24be5f"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90 146.96c-11.25 0-37.63-1.4-40.07-14.32-.12-.46-.17-.93-.17-1.4V75.86c0-.46.05-.93.17-1.4.65-3.45 3.06-6.4 7.16-8.81-1.03-1.76-1.31-3.43-1.31-4.72V48.57c0-6.12 6.2-9.03 12.27-11.05 5.94-1.99 13.74-3.08 21.95-3.08s16 1.1 21.95 3.08c6.06 2.02 12.26 4.93 12.26 11.05v3.22c0 1.66-1.35 3.01-3.01 3.01-1.66 0-3.01-1.35-3.01-3.01v-3.22c0-1.73-2.74-3.53-8.15-5.34-5.34-1.79-12.47-2.78-20.03-2.78-7.57 0-14.69.99-20.03 2.78-5.41 1.81-8.15 3.6-8.15 5.34v12.36c0 1.15.67 2.29 1.99 3.37a2.97 2.97 0 0 1 1.06 2.76 2.995 2.995 0 0 1-1.81 2.34c-4.26 1.81-6.83 4.02-7.22 6.24-.02.09-.04.18-.06.26v55.3c.03.09.05.18.06.26.98 5.58 15.03 9.47 34.16 9.47s33.19-3.89 34.16-9.47c.02-.09.04-.18.06-.26V75.91c-.03-.09-.05-.17-.06-.26-.26-1.48-1.86-3.34-4.06-4.74a3.01 3.01 0 0 1-.93-4.16 3.01 3.01 0 0 1 4.16-.93c3.69 2.33 6.14 5.48 6.76 8.65.12.46.17.93.17 1.4v55.39c0 .47-.05.93-.17 1.4-2.47 12.9-28.85 14.3-40.1 14.3zm34.23-15.79zm-68.46 0zm68.46-55.23zm-68.46 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxJar);
export default __webpack_public_path__ + "static/media/taxJar.72a46a91adcdf6c22080a65bc4554cf3.svg";
export { ForwardRef as ReactComponent };